module.exports = {"510802001":"东坝街道","510802002":"嘉陵街道","510802003":"河西街道","510802004":"雪峰街道","510802005":"南河街道","510802006":"上西街道","510802007":"回龙河街道","510802008":"杨家岩街道","510802100":"荣山镇","510802101":"大石镇","510802102":"盘龙镇","510802103":"宝轮镇","510802104":"赤化镇","510802105":"三堆镇","510802106":"工农镇","510802200":"白朝乡","510802201":"金洞乡","510802202":"龙潭乡","510802405":"袁家坝","510802407":"下西街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510802.json
// module id = 2129
// module chunks = 0